import { Intent, Position, Toaster } from '@blueprintjs/core'

const toaster = Toaster.create({
  className: 'recipe-toaster',
  position: Position.TOP
})

export default function showSuccess(message, intent = Intent.SUCCESS) {
  window.scrollTo(0, 0)
  toaster.show({ message: message, intent: intent, timeout: 1500 })
}
